import React from "react";
import { quickDateInput } from "@/lib/editDates";

export function DateShortcuts({ value, onChange, withTime = false, disabled = false }) {
  return (
    <div className="mt-2 flex flex-wrap gap-2" role="group" aria-label="Päivämäärän pikavalinnat">
      {[[0, "Tänään"], [1, "Huomenna"], [7, "Viikon päästä"]].map(([days, label]) => (
        <button key={days} type="button" disabled={disabled}
          onClick={() => onChange(quickDateInput(days, value, withTime))}
          className="min-h-10 rounded-full border border-border px-3 text-xs hover:border-primary hover:text-primary disabled:opacity-50">
          {label}
        </button>
      ))}
      {!withTime && <button type="button" disabled={disabled} onClick={() => onChange("")}
        className="min-h-10 rounded-full border border-border px-3 text-xs hover:text-primary disabled:opacity-50">Ei eräpäivää</button>}
    </div>
  );
}
